<template>
    <div>
        <el-dialog :close-on-click-modal="false" :visible.sync="showDialog" v-if="showDialog" :modal="false"
            class="myPicShowDialogClass" :destroy-on-close="true" fullscreen :show-close="showClose" append-to-body>
            <div>
                <el-container style="overflow-x: hidden">
                    <el-aside width="224px" style="
                        background-color: #ffffff;
                        margin-bottom: 0px;
                        margin-left: 0px;
                        margin-top: 0px;
                        overflow-x: hidden;
                        overflow-y: hidden;
                      ">
                        <div style="position: absolute;"><img src="../../assets/images/logo.png"
                                style="width:300px;margin-left: 15px; top: 2px" alt=""></div>
                        <el-menu :default-active="active" :default-openeds="activeNames" class="el-menu-vertical-demo"
                            @select="changeView" background-color="#ffffff" text-color="#646464"
                            active-text-color="#409EFF"
                            style="overflow-x: hidden;position: absolute;left: 0px;width: 224px;margin-top: 70px;">
                            <el-menu-item index="10">
                                <i class="el-icon-collection-tag"></i>
                                <span slot="title">个人档案</span>
                            </el-menu-item>

                            <el-menu-item index="40">
                                <i class="el-icon-first-aid-kit"></i>
                                <span slot="title">肺癌管理</span>
                            </el-menu-item>

                        </el-menu>
                    </el-aside>

                    <el-container>
                        <el-header>
                            <el-row>
                                <div style="margin-top: 12px">
                                    <el-button style="float: right; margin-right: 0px" type="primary" size="mini"
                                        icon="el-icon-arrow-left" @click="setDialogClosed">返回患者列表</el-button>
                                </div>
                            </el-row>
                        </el-header>

                        <el-main>
                            <div style="margin-left: 50px;">
                                <component :is="currentView" :pInfo="pInfo" v-if="update"></component>
                            </div>
                        </el-main>
                    </el-container>
                </el-container>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import personalFile from "../personalFile/index.vue";//个人档案
import lungManagement from "../lungManagement/index.vue";//肺癌管理


export default {
    components: {
        personalFile,
        lungManagement
    },
    data() {
        return {
            title: "",
            showDialog: false,
            showClose: false,
            activeNames: [],
            active: "10",
            currentView: "personalFile",
            pInfo: null,
            update: true
        };
    },
    methods: {
        // 编辑初始化页面内容
        async init(row) {
            this.showDialog = true;
            this.pInfo = row;
            // console.warn("初始化值", this.pInfo);
        },
        setDialogClosed() {
            this.currentView = "personalFile";
            this.showDialog = false;
        },
        changeView(view) {
            this.update = false;
            if (view == "10") {
                //个人档案
                this.currentView = "personalFile";
                this.$nextTick(() => {
                    this.update = true;
                });
            } else if (view == "40") {
                //肺癌管理
                this.currentView = "lungManagement";
                this.$nextTick(() => {
                    this.update = true;
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.addContact {
    position: absolute;
    top: 10px;
    right: 0;
    border: 1px solid gray;
    border-radius: 30px;
    width: 80px;
    display: inline-block;
    cursor: pointer;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    overflow-y: hidden;
}

.myPicShowDialogClass ::v-deep .el-dialog__header {
    padding: 0;
}

.myPicShowDialogClass::v-deep .el-dialog__body {
    padding: 0;
}

.myPicShowDialogClass::v-deep .el-dialog__footer {
    padding-bottom: 0px;
}

.el-aside {
    height: calc(100vh);
    overflow-y: hidden;
}

.el-main {
    padding: 0;
    height: calc(100vh - 330px);
}

::v-deep {
    .el-menu-item {
        padding-left: 50px !important;
    }

    // fileMenu
    .fileMenu .el-menu-item {
        padding-left: 80px !important;
    }

    .el-submenu .el-submenu__title {
        padding-left: 50px !important;
    }
}

// .labelRed {
//     border-radius: 50%;
//     color: white;
//     background: red;
//     padding: 3px;
// }

.labelRed {
    height: 24px;
    width: 24px;
    border-radius: 50%;
    color: white;
    background: red;
    display: inline-block;
}

.labelOrange {
    border-radius: 50%;
    color: white;
    background: orange;
    padding: 3px;
}

.labelGreen {
    border-radius: 50%;
    color: white;
    background: green;
    padding: 3px;
}

.labelGray {
    border-radius: 50%;
    color: white;
    background: gray;
    padding: 3px;
}

.labelNone {
    display: none;
}
</style>